import axios from "@/index";
const productType = {
  state: {
    baseDataProductTypeList: [],
    productTypeData: [],
    productTypeList: []
  },
  getters: {},
  actions: {
    getBaseDataProductTypeList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setBaseDataProductTypeList",
                (state, { baseDataProductTypeList: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getProductTypeInfo: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setProductTypeInfo",
                (state, { productTypeData: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    getProductTypeList: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setProductTypeList",
                (state, { productTypeList: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  mutations: {
    setBaseDataProductTypeList(state, action) {
      state.baseDataProductTypeList = action.baseDataProductTypeList;
    },
    setProductTypeInfo(state, action) {
      state.productTypeData = action.productTypeData;
    },
    setProductTypeList(state, action) {
      state.productTypeList = action.productTypeList;
    }
  }
};
export default productType;
